import LOGO from '../../assets/LOGO (2).png';

export const AuthLayout = ({ title, subtitle, children, showRightPanel = false, rightPanelContent = null }) => {
  return (
    <div className={`min-h-screen grid ${showRightPanel ? 'grid-cols-1 lg:grid-cols-[1fr_1fr]' : 'grid-cols-1'}`}>
      {/* Left Panel */}
      <div className="flex flex-col justify-center items-center bg-white relative px-6 py-10 sm:px-12 md:px-16 lg:px-0">
        <div className="relative z-10 flex w-full max-w-lg flex-col items-center gap-6">
          {/* Header */}
          <div className="text-center">
            <img src={LOGO} alt="logo-easy-survey" className="mx-auto mb-5 h-20 w-auto" />
            <h1 className="text-2xl font-semibold text-gray-900">{title}</h1>
            {subtitle && <p className="mt-2 text-base font-medium text-gray-700">{subtitle}</p>}
          </div>

          {/* Content */}
          {children}
        </div>
      </div>

      {/* Right Panel */}
      {showRightPanel && rightPanelContent}
    </div>
  );
};
